import Dialog from './Dialog/modalDialog'
import Message from './Message/index.js'
import Modal from './modal/index.js'
import Button from './button/index.js'
import Page from './page/index.js'
import Material from './Material/index.js'
import Translation from './Translation/index.js'
import llmsTask from './llmsTask/index.js'
 
//批量安装全局使用组件
const components = {
    Dialog,
    Message,
    Modal,
    Button,
    Page,
    Material,
    Translation,
    llmsTask
}
const install = function(Vue, opts = {}) {    
       Object.keys(components).forEach((key) => {        
        Vue.component(key, components[key]);    
    })
    Vue.prototype.$Message = Message;
    Vue.prototype.$Modal = Modal;
    Vue.prototype.$Material = Material;
    Vue.prototype.$Translation = Translation;
    Vue.prototype.$llmsTask=llmsTask;
}
export default install

 
// // 添加install方法安装在全局使用
// export default(
// Dialog.install = function(Vue) {
//   Vue.component(Dialog.name, Dialog);
// })

// export default(
// Message.install = function(Vue) {
//     Vue.component(Message.name, Message);
//   }
// )
 




// WEBPACK FOOTER //
// ./src/components/publicUi.js